<template>
    <v-card height="325">
        <v-toolbar color="primary">
            <v-btn icon @click="fechar"><v-icon color="white">close</v-icon></v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title style="color: white;">
                Cancelar compra
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
        </v-toolbar>
            <v-stepper v-model="step" style="box-shadow: none;">
                <v-stepper-items>
                    <v-stepper-content step="1">
                        <v-flex class="mt-4">
                            <h5 class="text-xs-center text--primary mb-2"
                                style="font-size: 1.2em;"
                            >
                                Requer PIN do gerente
                            </h5>
                        <v-text-field
                            :type="show ? 'text' : 'password'"
                            v-model="pin"
                            :append-icon="show ? 'visibility' : 'visibility_off'"
                            placeholder="****"
                            outline
                            counter="4"
                            single-line
                            hide-details
                            color="primary"
                            class="centered-input display-1 font-weight-black"
                            browser-autocomplete="off"
                            required
                            @click:append="show = !show"
                            :rules="[
                                    v => {
                                        if (v) {
                                        return v.length && v.length == 4 || ''
                                        } else {
                                        return false
                                        }
                                    }
                                    ]"
                            mask="NNNN"
                        />
                    </v-flex>
                    <v-card-actions class="justify-center">
                        <v-btn color="primary" class="mt-4 mb-4" @click="autenticar">Confirmar</v-btn>
                    </v-card-actions>
                    </v-stepper-content>
                    <v-stepper-content step="2">
                        <v-textarea v-model="texto" outline label="Motivo do cancelamento"/>
                        <v-card-actions class="justify-center">
                            <v-btn color="primary" :disabled="!texto" class="mb-2" @click="cancelamentoCompra">Confirmar</v-btn>
                        </v-card-actions>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>
    </v-card>
</template>
<script>
export default {
  props: ['voucher', 'compra'],
  data () {
    return {
      step: 1,
      texto: '',
      show: false,
      pin: ''
    }
  },
  methods: {
    fechar () {
      this.pin = ''
      this.show = false
      this.step = 1
      this.texto = ''
      this.$emit('fechar')
    },
    autenticar () {
      if (this.pin && this.pin !== '') {
        this.$store.dispatch('autenticarPin', { cnpj: this.frentista.posto.cnpj, pin: this.pin, id: this.frentista.id_frentista }).then(() => {
          this.step++
          this.pin = ''
          this.show = false
        }).catch(() => {
          this.step = 1
          this.pin = ''
          this.show = false
        })
      }
    },
    cancelamentoCompra () {
      this.$store.dispatch('cancelarCompra', {
        cnpj: this.frentista.posto.cnpj,
        id_compra_especie: this.compra.id_compra,
        motivo_cancelamento: this.texto
      }).then(() => {
        this.fechar()
      })
    }
  },
  computed: {
    frentista () {
      return this.$store.getters.frentista
    }
  }
}
</script>
